import mediumZoom from "medium-zoom";

export class MediumZoomModule {
  initialize() {
    const zoomableElements = document.querySelectorAll("[data-zoomable]");

    zoomableElements.forEach((element) => {
      if (element.dataset.zoomable != "") this.setBgElement(element);
      else this.getMediumZoom(element);
    });
  }

  setBgElement(element) {
    element.addEventListener("click", () => {
      const imgUrl = element.dataset.zoomable;
      const img = document.createElement("img");
      img.src = imgUrl;
      img.classList.add("zoomable-image");

      element.querySelector(".zoomable-container").appendChild(img);

      const zoom = this.getMediumZoom(img);

      zoom.on("closed", () => {
        img.classList.add("zoomable-image--disappear");
        img.remove();
      });

      zoom.open();
    });
  }

  getMediumZoom(element) {
    return mediumZoom(element, {
      margin: 65,
      background: "rgba(255, 255, 255, 0.95)",
    });
  }
}
